import { experiences } from "../data";
import SectionHeading from "./SectionHeading";

function Experience() {
  return (
    <section className="section container" id="experience">
      <SectionHeading title="Experience" />

      <div className="exp-list">
        {experiences.map((exp) => (
          <article className="exp-item" key={exp.company}>
            <div className="exp-side">
              <span className="mono">{exp.period}</span>
              <strong>
                <span className={`tone-dot tone-${exp.tone}`} />
                {exp.company}
              </strong>
              <span>{exp.location}</span>
            </div>

            <div className="exp-body">
              <h3>{exp.title}</h3>
              <p className="exp-desc">{exp.description}</p>

              {exp.missions.map((mission, index) => (
                <div className="exp-mission" key={index}>
                  {mission.title && <h4>{mission.title}</h4>}
                  <ul>
                    {mission.points.map((point) => (
                      <li key={point}>{point}</li>
                    ))}
                  </ul>
                  <p className="stack-line">{mission.stack.join(" / ")}</p>
                </div>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Experience;
